import { Columns } from "@fullscript/aviary-web";

import { Spacer, Skeleton } from "@aviary";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";

import * as styles from "./SignInForm.styles";

const SkeletonSignInForm = () => {
  const { tablet } = useBreakpoints();

  return (
    <>
      <Skeleton type="button" isFullWidth css={styles.marginBottom} />
      <Skeleton type="button" isFullWidth css={styles.marginBottom} />
      <div css={styles.row}>
        <Skeleton type="typography" typographySize="body" margin="topAndBottom" />
      </div>
      <Spacer height="one" />
      <Columns customCss={styles.row}>
        {!!tablet.greaterThan && (
          <Columns.Column columnWidth={6} phoneWidth={6} customCss={styles.flex}>
            <Skeleton type="button" width={1} height={1} />
            <Spacer width="half" />
            <Skeleton type="typography" typographySize="body" />
          </Columns.Column>
        )}
        <Skeleton type="button" isFullWidth />
      </Columns>
    </>
  );
};

export { SkeletonSignInForm };
